const style = {
  body_space: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  divid_y: {
    borderTop: "1px solid #E5E7EB",
  },
  gird_box: {
    grid_box: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px",
      borderRadius: "8px",
    },
    text: {
      fontSize: "14px",
      margin: 0,
      fontWeight: "bold",
    },
    total_code: {
      border: "solid 1px #91D5FF",
      backgroundColor: "#E6F7FF",
    },
    used_code: {
      border: "solid 1px #B7EB8F",
      backgroundColor: "#F6FFED",
    },
    unused_code: {
      border: "solid 1px #ffd591",
      backgroundColor: "#fff7e6",
    },
    void_code: {
      border: "solid 1px #FBA29E",
      backgroundColor: "#FEF1F0",
    },
  },
  table: {
    table_cell: {
      whiteSpace: "nowrap",
    },
  },
};

export default style;
